import {
    createResource,
    getResource,
    getResourceById,
    editResource,
    changeResourceStatus,
    deleteResource,
    uploadResourceDocument,
    editResourceDocument,
    getResourceDocument,
    deleteResourceDocument,
    editResourceAccess, getResourceAccess,
} from './resource.action';

export { resourceReducer } from './resource.reducer';
export { watchResource } from './resource.saga';

export const resourceActions = {
    /** Resource */
    createResource,
    editResource,
    changeResourceStatus,
    getResource,
    getResourceById,
    deleteResource,
    /** End */

    /** Resource Documents */
    uploadResourceDocument,
    editResourceDocument,
    getResourceDocument,
    deleteResourceDocument,
    /** End */

    /** Resource Access */
    editResourceAccess,
    getResourceAccess,
    /** End */
};
